import React from 'react';
import { Icon, Text } from '../../Atoms';
import userIcon from '../../assets/icons/user.svg';
import benefIcon from '../../assets/icons/benef.svg';

const BeneficiaryList = ({ contract, user }) => {
  return (
    <>
      <BeneficiaryItem
        isCurrentUser={true}
        name={`${user?.lastName} ${user?.firstName}`}
      />

      {contract.beneficiaries?.map((benef) => (
        <BeneficiaryItem key={benef.fullName} name={benef.fullName} />
      ))}
    </>
  );
};

const BeneficiaryItem = ({ name, isCurrentUser }) => {
  return (
    <div className="contract-item-container">
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          gap: 10
        }}
      >
        <div>
          <img src={isCurrentUser ? userIcon : benefIcon} />
        </div>

        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            gap: 5
          }}
        >
          <Text className="contract-title" text={name} />
          {isCurrentUser ? (
            <Text className="contract-benef-name" text="(vous)" />
          ) : null}
        </div>
      </div>

      <div className="remboursement-desktop-organism-sort-icon-container">
        <Icon icon={'SortTop'} size="20px" className="icon-next-step" />
      </div>
    </div>
  );
};

export default BeneficiaryList;
